import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, UserCheck, Clock, Activity } from 'lucide-react';
import type { ActiveUsers } from '../types/analytics.types';

interface ActiveUsersCardsProps {
  data: ActiveUsers | undefined;
  isLoading: boolean;
}

const cards = [
  { key: 'last24h' as const, label: 'Actifs 24h', icon: Clock, color: 'text-green-500' },
  { key: 'last7d' as const, label: 'Actifs 7 jours', icon: Activity, color: 'text-blue-500' },
  { key: 'last30d' as const, label: 'Actifs 30 jours', icon: UserCheck, color: 'text-purple-500' },
  { key: 'totalActive' as const, label: 'Total actifs', icon: Users, color: 'text-copper' },
];

export function ActiveUsersCards({ data, isLoading }: ActiveUsersCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(({ key, label, icon: Icon, color }) => {
        const value = data?.[key] ?? 0;
        const percentage = data?.totalActive ? Math.round((value / data.totalActive) * 100) : 0;

        return (
          <Card key={key}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
              <Icon className={`h-4 w-4 ${color}`} />
            </CardHeader>
            <CardContent>
              {isLoading ? (
                <div className="h-8 w-16 bg-muted animate-pulse rounded" />
              ) : (
                <>
                  <div className="text-2xl font-bold">{value}</div>
                  {key !== 'totalActive' && (
                    <p className="text-xs text-muted-foreground mt-1">
                      {percentage}% des utilisateurs actifs
                    </p>
                  )}
                </>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
